'use client' // necessary when in App Router

import { Provider as ReduxProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from 'state/store'
import { usePathname } from 'next/navigation'

/**
 * Routes where the global store must finish redux-persist rehydration before children render.
 * - `/app/bookings` — Pages Router booking flows using persisted `booking` / `bookingHelper` / `consent`.
 * - `/bookings` is intentionally omitted: App Router v2 booking (`/bookings/new`, etc.) uses a
 *   dedicated store + PersistGate in `InitializeBookingRedux.tsx`, not the global persistor.
 */
const PERSIST_ROUTES = ['/app/bookings', '/login', '/app/sign-patient-consent']

interface ReduxProvidersProps {
  children: React.ReactNode
}

export function ReduxProviders({ children }: ReduxProvidersProps): JSX.Element {
  const pathname = usePathname()
  const needsPersistGate = PERSIST_ROUTES.some((route) =>
    pathname?.startsWith(route)
  )

  return (
    <ReduxProvider store={store}>
      {needsPersistGate ? (
        <PersistGate persistor={persistor}>{children}</PersistGate>
      ) : (
        <>{children}</>
      )}
    </ReduxProvider>
  )
}
